module.exports = __webpack_public_path__ + "static_pc/img/ba11.e504ab5c.png";